<template>
    <!-- модальное окно создания/отправки смс -->
    <modal>
        <template v-slot:title>{{ $t('sendMessage') }}</template>
        <template v-slot:head-bottom>
            <button type="button" class="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-email"  @click="$emit('close')"><i class="ri-close-fill align-bottom"></i></button>
        </template>
        <template v-slot:body>
                <div class="mb-3">
                    <h4 class="fs-15">{{ $t('enterPhoneNumber') }}</h4>
                    <input type="number" class="form-control" id="contactNumber" v-model="this.form.userPhone" placeholder="+380">
                </div>

                <div class="alert alert-warning" role="alert" v-if="this.viberJSON.defaultSMS.length > 133">
                    {{ $t("sendOnlyInViber") }}.
                </div>

                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="this.forceSend" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">
                        {{ $t('forceSend') }} 
                    </label>
                </div>

                <autotag :link="this.form.url" @inputCustom="inputText"></autotag>

                <div class="mb-3" v-if="this.viberJSON.viberSMS">
                    <h4 class="fs-15">Viber</h4>
                    <textarea
                        class="form-control" 
                        disabled="true"
                        rows="6" 
                        v-model="this.viberJSON.viberSMS"
                    ></textarea>
                </div>
        </template>
        <template v-slot:footer-bottom>
            <button class="btn link-success fw-medium" @click="$emit('close')"><i class="ri-close-line me-1 align-middle"></i> {{ $t('close') }} </button>
            <button type="button" class="btn btn-primary" @click="sendSms">{{ $t('Add') }}</button>
        </template>
    </modal>
</template>

<script>
import modal from '@/components/modal-small' 
import autotag from '@/components/autotag'
import { Clients } from '@/API'
import { v4 as uuidv4 } from 'uuid';

let apiServe = new Clients();

export default ({
    data(){
        return {
            viberJSON: {
                defaultSMS: '',
                viberSMS: '',
                viberButton: {
                    label: '',
                    href: ''
                }
            },
            form:{
                userPhone: "",
                text: "",
                company: '',
                formId: ''
            },
            forceSend: false
        }
    },
    props:['link', 'phone', 'obj'],
    components: { modal, autotag},
    created(){
        // this.form.url = this.link
        if(this.phone){
            this.form.userPhone = this.phone
        }
    },
    methods: {
        inputText(text, viberText){
            console.log(...arguments)
            if(viberText && text) {
                this.viberJSON.defaultSMS = text.message
                this.viberJSON.viberSMS = viberText.text
                this.viberJSON.viberButton = viberText.button
            } else if(text && !viberText) {
                this.viberJSON.defaultSMS = text.message
                this.viberJSON.viberSMS = text.message
            } else {
                this.form.text = '';
            }
    
            console.log(this.form.text)
        },
        sendSms(){
            // START
            // Йде перевірка на кількість символів
            /* 
                Якщо не стоїть галочка на примусову відправку, 
                то при довжині повідомлення більше 133 символи,
                з форми буде видалятися зміст дефолтного смс.
                Якщо така галочка стоїть, то СМС не буде летіти у Вайбер,
                а тільки на телефон клієнта
            */
            if(this.forceSend === true) {
                this.viberJSON.viberSMS = ''
            } else if(this.viberJSON.defaultSMS.length > 133 && this.forceSend === false){
                this.viberJSON.defaultSMS = ''
            }
            // END

            this.form.text = this.viberJSON // присвоюємо дані в форму і відправляємо
            
            if (!this.form.userPhone) {
                //перевіряємо чи вказаний номер
                this.$toast.error(this.$t('EnterNumber'));
            } else
            if (!this.form.text) {
                //перевіряємо чи вказаний текст
                this.$toast.error(this.$t('EnterSms'));
            } else {    
                this.form["formId"] = uuidv4();
                this.form.company = this.obj?.companyId    
                this.$emit('sendSMS', this.form)
                this.$emit('close')
            }
        }
    }
})
</script>
